/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/reEvaluate.js
 ** module id = 57
 ** module chunks = 0
 **/